import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

const ENDPOINT = '/api/seo/vitals';

function detectDevice(): 'mobile' | 'desktop' {
  if (typeof window === 'undefined') return 'desktop';
  return window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
}

function send(metric: Metric) {
  const body = JSON.stringify({
    metric: metric.name,
    value: metric.value,
    rating: metric.rating,
    path: window.location.pathname,
    device: detectDevice(),
  });
  // Prefer sendBeacon — survives page unload, doesn't block navigation.
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(ENDPOINT, blob);
    return;
  }
  fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {
    /* best-effort */
  });
}

/**
 * Boot web-vitals collection. Call once at app start. Each metric fires
 * once per page-load with its final value (CLS aggregates on visibility
 * change; INP/LCP report the worst observed).
 */
export function bootWebVitalsBeacon() {
  if (import.meta.env.DEV) return;

  onCLS(send);
  onFCP(send);
  onINP(send);
  onLCP(send);
  onTTFB(send);
}
